import { createFileRoute } from '@tanstack/react-router';
import { isPermissionParcialOrFull } from '@/features/login/util/permission';
import { Pdv } from '@/features/pdv/page/Pdv';
import { validateRoute } from '@/router/util';

export const Route = createFileRoute('/a/pdv')({
    beforeLoad: () =>
        validateRoute({
            fintech: false,
            validatePermission: ({ upp_fiscal_nfce }) => isPermissionParcialOrFull(upp_fiscal_nfce),
        }),
    component: Pdv,
});
